<template>
    <span class="mb-0">
        <span class="text-dark bold-text" @click="actionLabel">{{title}}: </span>
        <span class="text-muted">
            <slot></slot>
        </span>
    </span>
</template>

<script>
    export default {
        name: "Mlabel",
        props: {
            title: {required: true, type: String, default: 'title'}
        },
        methods: {
            actionLabel () {
                this.$emit('action')
            }
        }
    }
</script>

<style scoped>

</style>
